import { useTranslation } from "react-i18next";

import { PLANS } from "@botwsp/shared";

import { formatCurrency, formatNumber } from "@/lib/format";
import { useAuth } from "@/features/auth/authContext";

export function BillingPage() {
  const { t } = useTranslation(["billing"]);
  const { tenantPlan } = useAuth();
  const currentPlan = tenantPlan;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">{t("billing:title")}</h1>
      {currentPlan && (
        <p className="text-sm text-slate-500">
          {t("billing:currentPlanLabel", { plan: currentPlan })} {t("billing:subscriptionNote")}
        </p>
      )}

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        {Object.values(PLANS).map((p) => (
          <div key={p.code} className={`card flex flex-col ${p.code === currentPlan ? "ring-2 ring-brand-500" : ""}`}>
            <div className="card-header">
              <h2 className="text-base font-semibold">{p.name}</h2>
              <p className="mt-1 text-2xl font-bold">
                {p.isEnterprise
                  ? t("billing:customPrice")
                  : t("billing:perMonth", { price: formatCurrency(p.monthlyPriceUsd) })}
              </p>
              <p className="text-xs text-slate-400">
                {t("billing:conversationsPerMonth", {
                  count: p.conversationLimit,
                  formattedCount: formatNumber(p.conversationLimit),
                })}
              </p>
            </div>
            <ul className="card-body flex-1 space-y-1 text-sm text-slate-600">
              {p.features.map((f) => (
                <li key={f}>• {f}</li>
              ))}
              <li className="pt-2 text-xs text-slate-400">
                {t("billing:modulesLabel")} {p.modules.join(", ")}
              </li>
            </ul>
            <div className="card-body pt-0">
              <button className="btn-secondary w-full" disabled={p.code === currentPlan}>
                {p.code === currentPlan ? t("billing:currentBadge") : t("billing:choose", { name: p.name })}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
